export const admin = {
    title: 'FSD Admin',
    header: {
        title: 'Painel Administrativo',
        toggleMenu: 'Alternar menu',
    },
    nav: {
        dashboard: 'Dashboard',
        newDrones: 'Drones Novos',
        usedDrones: 'Drones Usados',
        buffalo: 'Linha Buffalo',
        powerCitros: 'Power Citros',
        parts: 'Peças e Acessórios',
    },
    dashboard: {
        title: 'Dashboard',
        description: 'Bem-vindo ao painel administrativo da Fronteira Sul Drones',
        stats: {
            totalNewDrones: 'Drones Novos',
            totalUsedDrones: 'Drones Usados',
            totalBuffalo: 'Linha Buffalo',
            totalPowerCitros: 'Power Citros',
            totalParts: 'Peças e Acessórios',
        },
    },
    newDrones: {
        title: 'Drones Novos',
        description: 'Gerencie os drones novos cadastrados no sistema',
        empty: 'Nenhum drone novo cadastrado. Clique em "Adicionar Drone" para começar.',
        addButton: 'Adicionar Drone',
    },
    usedDrones: {
        title: 'Drones Usados',
        description: 'Gerencie os drones usados cadastrados no sistema',
        empty: 'Nenhum drone usado cadastrado. Clique em "Adicionar Drone" para começar.',
        addButton: 'Adicionar Drone',
    },
    buffalo: {
        title: 'Linha Buffalo',
        description: 'Gerencie os itens de motores e acoplados da Linha Buffalo',
        empty: 'Nenhum item da Linha Buffalo cadastrado. Clique em "Adicionar" para começar.',
        addButton: 'Adicionar Item Buffalo',
    },
    powerCitros: {
        title: 'Power Citros',
        description: 'Gerencie os produtos da linha Power Citros — ultra limpador desengraxante cítrico',
        empty: 'Nenhum produto Power Citros cadastrado. Clique em "Adicionar" para começar.',
        addButton: 'Adicionar Produto Power Citros',
    },
    parts: {
        title: 'Peças e Acessórios',
        description: 'Gerencie as peças e acessórios cadastrados no sistema',
        empty: 'Nenhuma peça ou acessório cadastrado. Clique em "Adicionar" para começar.',
        addButton: 'Adicionar Peça/Acessório',
    },
    theme: {
        toggle: 'Alternar tema',
        light: 'Tema claro',
        dark: 'Tema escuro',
        system: 'Tema do sistema',
    },
};
//# sourceMappingURL=admin.js.map